import { translateRich, useLocale } from "../../localization";
import React from "react";
import { List, ListItem, Typography } from "@mui/material";
import Experience from "../dashboard/Experience";
import { Panel } from "../ui";

const CollectionExperiencesSection = ({ experiences }) => {
  useLocale();
  return (
    <section className="collectionDetailSection">
      <Typography className="collectionDetailSectionTitle" variant="h5">{translateRich("Experiences ({value0})", {
  value0: experiences.length
})}</Typography>

      <div className="experiencesPage collectionDetailExperienceList">
        <List className="experiencesList app-row-list">
          {experiences.map((experience) => (
            <ListItem
              component={Panel}
              key={experience.experienceId || experience.id}
              hoverable
            >
              <Experience experience={experience} />
            </ListItem>
          ))}
        </List>
      </div>
    </section>
  );
};

export default CollectionExperiencesSection;
